<mat-chip-listbox>
  <mat-chip-option *ngFor="let chip of chips">
    {{chip}}
  </mat-chip-option>
</mat-chip-listbox>
